import { NgModule } from '@angular/core';
import { PlainTextService } from './plainText.service';
import { DatePipeModule } from "libraries/date/date.module";
import { LabelModule } from '../label/label.module';

@NgModule({
    imports: [
        DatePipeModule,
        LabelModule,
    ],
    providers: [
        PlainTextService,
    ]
})
export class PlainTextModule {  }